import React from 'react';
import { Box, TableCell, TableRow, Typography } from '@mui/material';
import CalendarIcon from '../../../../../assets/svg/calendar_month.svg?react';
import { Helpers } from '../../../../common/helpers/helpers';
import { LibraryItem, LibraryListRowProps } from './types';
import { useAppSelector } from '../../../../common/hooks/useAppSelector';
import { selectAllCompanies } from '../../../../slices/companies/companiesSlice';
import { selectAllDocuments } from '../../../../slices/documents/documentsSlice';
import { useTranslation } from 'react-i18next';
import { useLibraryFunctions } from '../../hooks/useLibraryFunctions';
import styles from './LibraryList.module.scss';
import InfoIcon from '@mui/icons-material/Info';
import TemplatePreview from '../template-preview/TemplatePreview';
import TemplatePreviewTooltip from '../template-preview-tooltip/TemplatePreviewTooltip';

export const LibraryListRow = ({ item, renderActionButtons }: LibraryListRowProps) => {
  const company = useAppSelector(selectAllCompanies)[0];
  const { t } = useTranslation();
  const documentUploads = useAppSelector(selectAllDocuments);
  const freePlan = !company?.stripe_product_id && !company?.plan_settings.stripe_product_id;
  const { setPlanUpgradingMessage, navigateToTemplatePage } = useLibraryFunctions();
  const handleNavigate = (item: LibraryItem) => {
    const actionAvailableFree = 'is_free' in item && item.is_free;
    if (item.download_link) {
      return false;
    } else {
      if (!('region' in item)) {
        navigateToTemplatePage('company-templates', item.id);
      } else {
        if (freePlan) {
          if (actionAvailableFree) {
            navigateToTemplatePage(item.region, item.id);
          } else {
            setPlanUpgradingMessage(true);
          }
        } else {
          navigateToTemplatePage(item.region, item.id);
        }
      }
    }
  };

  return (
    <TableRow className={styles.table_row}>
      <TableCell className={styles.table_cell} onClick={() => handleNavigate(item)}>
        <Box className={styles.profile_container}>
          <div className={styles.title_container}>
            <Typography variant='body2' className={styles.profile_text}>
              {item.name
                ? item.name
                : documentUploads.find((el) => el.id === item.document_upload)?.name ||
                  t('templatePage.headerDefault')}
            </Typography>
            {item.is_free && !company.stripe_subscription && !company.stripe_product_id && (
              <Box className={styles.free_tag}>{t('pricingOptionNames.free')}</Box>
            )}
          </div>
          {item.description && (
            <TemplatePreviewTooltip
              title={
                <TemplatePreview
                  description={item.description}
                  fines={item.fines}
                  resolution={item.resolution}
                />
              }
              arrow
              placement='top'
            >
              <InfoIcon color='primary' fontSize='small' />
            </TemplatePreviewTooltip>
          )}
        </Box>
      </TableCell>
      <TableCell className={styles.table_cell} onClick={() => handleNavigate(item)}>
        <Typography
          variant='body2'
          sx={{ textTransform: 'capitalize' }}
          className={styles.cell_text}
        >
          {item.category ? item.category : '-'}
        </Typography>
      </TableCell>
      <TableCell className={styles.table_cell} onClick={() => handleNavigate(item)}>
        <Typography variant='body2' className={styles.cell_text}>
          {'dl_workflows' in item
            ? item.dl_workflows.length > 0
              ? item.dl_workflows.join(', ')
              : '-'
            : item.dt_workflows.length > 0
              ? item.dt_workflows.join(', ')
              : '-'}
        </Typography>
      </TableCell>
      <TableCell className={styles.table_cell} onClick={() => handleNavigate(item)}>
        <Typography variant='body2' className={styles.cell_text}>
          {'dl_types' in item
            ? item.dl_types.length > 0
              ? item.dl_types.join(', ')
              : '-'
            : item.dt_types.length > 0
              ? item.dt_types.join(', ')
              : '-'}
        </Typography>
      </TableCell>
      <TableCell className={styles.table_cell} onClick={() => handleNavigate(item)}>
        <Box className={styles.date_container}>
          <CalendarIcon />
          <Typography variant='body2' className={styles.cell_text}>
            {'updated' in item ? Helpers.timeStampToDateV2(item.created) : '2026'}{' '}
            {/*2025 - just a placeholder*/}
          </Typography>
        </Box>
      </TableCell>
      <TableCell className={styles.table_cell}>{renderActionButtons(item)}</TableCell>
    </TableRow>
  );
};
